import { useEffect, useRef } from 'react';
import { setBarColor } from '../lib/theme';

/* S1. Заставка — только при запуске с нуля. Слайдшоу собирается кодом из
   слоёв-картинок (public/slides), а не видео: меньше вес, набор легко
   пересобрать к празднику, одинаково в вебе и в Capacitor.
   0–0,9 с логотип → раскол по диагонали → поток кусков фото и наклеек →
   5,4 с притемнение и плашка → 7 с. Данные ещё грузятся — поток идёт дальше. */

const SHAPES: Record<string, { clip: string; box: [number, number, number, number] }> = {
  full: { clip: 'polygon(0 0,100% 0,100% 100%,0 100%)', box: [0, 0, 100, 100] },
  b1: { clip: 'polygon(0 0,100% 0,100% 28.6%,0 36.6%)', box: [0, 0, 100, 37] },
  b2: { clip: 'polygon(0 37.5%,100% 29.5%,100% 62.5%,0 69.5%)', box: [0, 29, 100, 41] },
  b3: { clip: 'polygon(0 70.5%,100% 63.5%,100% 100%,0 100%)', box: [0, 63, 100, 37] },
  cL: { clip: 'polygon(0 0,57% 0,41% 100%,0 100%)', box: [0, 0, 57, 100] },
  cR: { clip: 'polygon(59% 0,100% 0,100% 100%,43% 100%)', box: [43, 0, 57, 100] },
  gT: { clip: 'polygon(0 0,100% 0,100% 50%,0 58%)', box: [0, 0, 100, 58] },
  gL: { clip: 'polygon(0 59.6%,48.6% 55.6%,44.6% 100%,0 100%)', box: [0, 55, 49, 45] },
  gR: { clip: 'polygon(50.6% 55.4%,100% 51.6%,100% 100%,46.6% 100%)', box: [46, 51, 54, 49] },
  fr: { clip: 'polygon(9% 22%,91% 17%,93% 68%,7% 74%)', box: [7, 17, 86, 57] },
  kT: { clip: 'polygon(26% 0,100% 0,100% 50%)', box: [26, 0, 74, 50] },
  kB: { clip: 'polygon(0 48%,74% 100%,0 100%)', box: [0, 48, 74, 52] },
};

type Slide = { t: number; img?: string; pos?: string; shape?: string; from?: string; st?: string; css?: string; r?: number };
const SEQ: Slide[] = [
  { t: 0, img: 'full-p04.jpg', pos: '50% 30%', shape: 'full', from: 'z' },
  { t: 320, img: 'pan-p11.jpg', shape: 'b1', from: 'l' },
  { t: 500, img: 'pan-p12.jpg', pos: '50% 40%', shape: 'b2', from: 'r' },
  { t: 680, img: 'pan-p14.jpg', shape: 'b3', from: 'b' },
  { t: 900, st: 'st-p01.webp', css: 'left:-3%;bottom:-3%;width:40%', r: -3 },
  { t: 1080, st: 'st-p03.webp', css: 'left:40%;bottom:12%;width:64%', r: 5 },
  { t: 1380, img: 'full-p08.jpg', pos: '50% 30%', shape: 'cL', from: 't' },
  { t: 1560, img: 'pan-p02.jpg', shape: 'cR', from: 'b' },
  { t: 1780, st: 'st-p05.webp', css: 'left:-7%;bottom:-3%;width:58%', r: -4 },
  { t: 2020, img: 'pan-p07.jpg', pos: '50% 32%', shape: 'fr', from: 'z' },
  { t: 2240, st: 'st-p16.webp', css: 'left:57%;bottom:6%;width:44%', r: 4 },
  { t: 2540, img: 'pan-p13.jpg', pos: '50% 28%', shape: 'gT', from: 't' },
  { t: 2720, img: 'pan-p11.jpg', shape: 'gL', from: 'l' },
  { t: 2900, img: 'full-p10.jpg', pos: '50% 35%', shape: 'gR', from: 'r' },
  { t: 3140, st: 'st-p06.webp', css: 'left:-12%;top:14%;width:70%', r: -5 },
  { t: 3340, st: 'st-p09.webp', css: 'left:42%;bottom:-4%;width:62%', r: 4 },
  { t: 3620, img: 'pan-p14.jpg', shape: 'kT', from: 'r' },
  { t: 3800, img: 'pan-p12.jpg', pos: '50% 40%', shape: 'kB', from: 'l' },
  { t: 4040, st: 'st-p15.webp', css: 'left:-8%;bottom:1%;width:62%', r: -3 },
];
const DIR = import.meta.env.BASE_URL + 'slides/';
const LOGO = 900;
const FINAL = 5400;
export const SPLASH_TOTAL = 7000;
const KEEP = 34;

function slideshow(root: HTMLElement) {
  const ss = root.querySelector('.ss') as HTMLElement;
  const T: ReturnType<typeof setTimeout>[] = [];
  const at = (ms: number, fn: () => void) => T.push(setTimeout(fn, ms));
  const add = (cls: string, html: string, style?: string) => {
    const el = document.createElement('div');
    el.className = cls;
    if (style) el.style.cssText = style;
    el.innerHTML = html;
    ss.appendChild(el);
    const all = ss.querySelectorAll('.pc,.stk');
    if (all.length > KEEP) all[0].remove();
    return el;
  };
  const piece = (x: Slide) => {
    const sh = SHAPES[x.shape!];
    const [l, t, w, h] = sh.box;
    add(
      'pc' + (x.shape === 'full' ? ' full' : '') + ' from-' + (x.from || 'z'),
      `<div class="pcc" style="clip-path:${sh.clip}"><img src="${DIR + x.img}" alt="" style="left:${l}%;top:${t}%;width:${w}%;height:${h}%${x.pos ? ';object-position:' + x.pos : ''}"><i class="ht"></i></div>`,
    );
  };
  const sticker = (x: Slide) => add('stk', `<img src="${DIR + x.st}" alt="">`, x.css + ';--r:' + x.r + 'deg');

  /* Картинки — заранее, чтобы кадр не лёг пустым. Набора нет — остаётся логотип */
  let missing = false;
  for (const f of new Set(SEQ.map((x) => x.img || x.st))) {
    const im = new Image();
    im.onerror = () => (missing = true);
    im.src = DIR + f;
  }
  function run(first: boolean) {
    const seq = first ? SEQ : SEQ.slice(1);
    const shift = first ? 0 : seq[0].t - 200;
    if (!first)
      ss.querySelectorAll('.dim,.cap').forEach((el) => {
        el.classList.add('out');
        setTimeout(() => el.remove(), 400);
      });
    seq.forEach((x) => at(x.t - shift, () => (x.st ? sticker(x) : piece(x))));
    at(FINAL - LOGO, () => {
      add('dim', '');
      add('cap', '<span>Тренерграм</span>');
    });
    at(SPLASH_TOTAL - LOGO, () => run(false));
  }
  at(LOGO, () => {
    if (missing) return;
    const split = document.createElement('div');
    split.className = 'split';
    split.innerHTML = '<i class="sa"></i><i class="sb"></i>';
    root.appendChild(split);
    root.classList.add('go');
    setTimeout(() => split.remove(), 900);
    run(true);
  });
  return () => T.forEach(clearTimeout);
}

/** Подгонка знака под ширину: срез — доля от кегля */
function fit(wm: HTMLElement) {
  const box = (wm.parentElement?.clientWidth || 320) - 56;
  const span = wm.querySelector('span') as HTMLElement;
  let size = 64;
  let guard = 0;
  const apply = () => {
    span.style.fontSize = size + 'px';
    wm.style.setProperty('--c', (size * 0.34).toFixed(1) + 'px');
  };
  apply();
  while (wm.offsetWidth > box && size > 14 && guard++ < 100) {
    size--;
    apply();
  }
}

export function Splash({ onTap }: { onTap: () => void }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const root = ref.current!;
    setBarColor('#FC5200');
    const wm = root.querySelector('.wm') as HTMLElement;
    fit(wm);
    document.fonts?.ready.then(() => fit(wm));
    const off = slideshow(root);
    return () => {
      off();
      setBarColor(null);
    };
  }, []);
  return (
    <main className="scr scr-splash">
      <div ref={ref} className="splash play" role="button" aria-label="Продолжить" onClick={onTap}>
        <div className="wm">
          <span>Тренерграм</span>
        </div>
        <div className="ss" aria-hidden="true" />
      </div>
    </main>
  );
}
